export enum Cookies {
  BRIGHTNESS = "brightness",
  LOCALE = "locale",
  NAVIGATION = "navigation",
  CONTENT_SORT = "content_sort",
  FILE_MANAGER_VIEW_MODE = "file_manager_view_mode",
  FILE_MANAGER_GENERATE_PUBLIC_LINK_OPTIONS = "file_manager_generate_public_link_options"
}
